// extracted by mini-css-extract-plugin
export default {"topBottomOverflowFade":"NotesText_topBottomOverflowFade__mJVX7","fade":"NotesText_fade__swNRp"};